// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1Rl6h","title":"ClientReferral_title__3ibgJ","itemText":"ClientReferral_itemText__17SmT"};